import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-dark-border py-12 mt-20">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">{t('footer.tool')}</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/" className="hover:text-safe transition-colors">{t('footer.analyzeEmail')}</Link></li>
              <li><Link to="/history" className="hover:text-safe transition-colors">{t('footer.history')}</Link></li>
              <li><Link to="/community" className="hover:text-safe transition-colors">{t('footer.community')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">{t('footer.information')}</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/about" className="hover:text-safe transition-colors">{t('footer.about')}</Link></li>
              <li><a href="/faq/" className="hover:text-safe transition-colors">{t('footer.faq')}</a></li>
              <li><a href="/api-docs/" className="hover:text-safe transition-colors">{t('footer.api')}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">{t('footer.legal')}</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><a href="/privacy/" className="hover:text-safe transition-colors">{t('footer.privacy')}</a></li>
              <li><a href="/terms/" className="hover:text-safe transition-colors">{t('footer.terms')}</a></li>
              <li><a href="/contact/" className="hover:text-safe transition-colors">{t('footer.contact')}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-3">{t('footer.ecosystem')}</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><a href="https://scamsandbox.com" className="hover:text-safe transition-colors" rel="noopener">ScamSandbox</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-dark-border pt-6 text-center text-gray-600 text-xs">
          &copy; {new Date().getFullYear()} SpamSandbox. {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
}
